import { render, staticRenderFns } from "./ConfiguracaoFaturamento.vue?vue&type=template&id=5f77f7e9&"
import script from "./ConfiguracaoFaturamento.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoFaturamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports